import { bindable, customElement } from 'aurelia';
import template from './collection-tree-node.html';

/** In-memory tree node built from the flat `CollectionTreeNode` DTO list — see
 *  `collection-tree-modal.ts`'s `_buildTree`. */
export interface CollectionTreeItem {
  id: string;
  title: string;
  parentId: string | null;
  children: CollectionTreeItem[];
  expanded: boolean;
  subtitle?: string | null;
  collectionDate?: string | null;
  collectionDateTo?: string | null;
  coverPreviewUrl?: string | null;
}

/** A single recursive row in the collection tree view (drag-and-drop reparenting). All actual
 *  state (drag source, hover target, API calls) lives in `collection-tree-modal.ts` — this
 *  component is purely presentational and recurses into its own `children` via itself, forwarding
 *  the same callback bindables down at every level so there's a single source of truth. */
@customElement({ name: 'collection-tree-node', template })
export class CollectionTreeNode {
  @bindable public node!: CollectionTreeItem;
  @bindable public draggedId: string | null = null;
  @bindable public dragOverId: string | null = null;
  @bindable public allowDrag = true;
  @bindable public allowToggle = true;
  @bindable public showHoverDetails = false;
  @bindable public allowCreate = false;
  @bindable public isRoot = false;
  @bindable public rootTitle = '';
  @bindable public createTitle = '';
  @bindable public selectedId: string | null = null;
  @bindable public onToggle: (node: CollectionTreeItem, event?: Event) => void = () => {};
  @bindable public onSelect: (node: CollectionTreeItem) => void = () => {};
  @bindable public onCreate: (node: CollectionTreeItem, event?: Event) => void = () => {};
  @bindable public onDragStart: (node: CollectionTreeItem, event: DragEvent) => void = () => {};
  @bindable public onDragOver: (node: CollectionTreeItem, event: DragEvent) => void = () => {};
  @bindable public onDragLeave: () => void = () => {};
  @bindable public onDrop: (node: CollectionTreeItem, event: DragEvent) => void = () => {};
  @bindable public onDragEnd: () => void = () => {};

  public get hasChildren(): boolean {
    return this.node.children.length > 0;
  }
}
